import { Button } from 'components/elements/button/button'
import './_cta.scss'
import { Header } from 'components/layout/header'
import { SimpleHeader } from 'components/layout/header/simple/simple-header'

interface CtaProps {
  header: React.ComponentProps<typeof Header>
  link: React.ComponentProps<typeof Button>
}

export const Cta = ({ header, link }: CtaProps) => {
  const { heading, ingress } = header.data

  return (
    <div className='cta'>
      {(heading || ingress) && (
        <SimpleHeader
          heading={{ ...heading, level: 1, weight: 700, size: 'display' }}
          ingress={ingress}
          className='cta__content'
        />
      )}
      {link && (
        <div className='cta__button-wrapper'>
          <Button {...link} size='m' />
        </div>
      )}
    </div>
  )
}
